import { Response, Signature, apiAbortController } from '@ui/src';
import api from '../../api/api';
import { MfaToken, MfaType } from '../types';

export const signatureTransationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTransactionSignature: build.query<
      Response<Signature>,
      { url: string; id: string }
    >({
      query: (data) => ({
        url: `/v1/${data.url}/${data.id}/signatures?all=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createTransactionSignature: build.mutation<
      { data: Signature },
      { url: string; id: string; body: Signature }
    >({
      query: (data) => ({
        url: `/v1/${data.url}/${data.id}/signatures`,
        method: 'POST',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    batchCreateTransactionSignature: build.mutation<
      { data: Signature },
      {
        mfaToken: string;
        transactionId: string[];
      }
    >({
      query: (data) => ({
        url: '/v1/signatures/batch-create',
        method: 'POST',
        body: data,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    sendCode: build.mutation<{ data: MfaToken }, { mfa: MfaType }>({
      query: (body) => ({
        url: '/v1/mfa/signatures/send-code',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    validateCode: build.mutation<
      { data: MfaToken },
      { mfaToken: string; totpToken: string }
    >({
      query: (body) => ({
        url: '/v1/mfa/signatures/verify-totp',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetTransactionSignatureQuery,
  useCreateTransactionSignatureMutation,
  useSendCodeMutation,
  useValidateCodeMutation,
  useBatchCreateTransactionSignatureMutation,
} = signatureTransationApi;

export const {
  endpoints: {
    getTransactionSignature,
    createTransactionSignature,
    sendCode,
    validateCode,
    batchCreateTransactionSignature,
  },
} = signatureTransationApi;
